import React from "react";
import WiiMote from "../WiimoteLib/WiiMote";

export default ({ device }: { device: WiiMote }) => {
  return (
    <div>
      <div>Accelometer coming soon ;)</div>
    </div>
  );
};
